import { domready } from './domready'

domready(function autoSubmitForm() {
  const forms = document.querySelectorAll<HTMLFormElement>(
    '.js-autosubmit-form'
  )
  if (forms.length === 0) return

  if (forms.length > 1) {
    throw `Expected only one form to automatically submit, but found ${forms.length}`
  }

  forms[0].submit()
})
